import { createSlice } from '@reduxjs/toolkit';

import { Item } from '@/types/item/Item';

import { loadChairishSimilarItems } from './chairishSimilarItems.actions';
import { ChairishItem, defaultChairishSimilarItemsSlice, isChairishItem } from './chairishSimilarItems.types';

const chairishSimilarItemsSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(loadChairishSimilarItems.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(loadChairishSimilarItems.fulfilled, (state, { payload }) => {
            const allItems = payload.carousels.flatMap((group) => group.items) as (ChairishItem | Item)[];
            const chairishItems = allItems
                .filter(isChairishItem)
                .map(({ imageUrl, lotId, lotUrl, originSystem, slug, startPrice, title }) => ({
                    imageUrl,
                    lotId,
                    lotUrl,
                    originSystem,
                    slug,
                    startPrice: startPrice ?? 0,
                    title,
                }));

            state.byId[payload.itemId] = chairishItems;
            state.loaded[payload.itemId] = Date.now();
            state.loading = false;
        });

        builder.addCase(loadChairishSimilarItems.rejected, (state) => {
            state.loading = false;
        });
    },
    initialState: defaultChairishSimilarItemsSlice,
    name: 'chairishSimilarItems',
    reducers: {},
});

export const { reducer: chairishSimilarItemsReducer } = chairishSimilarItemsSlice;
